var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-auto-dropzone",class:{ dropzone: _vm.includeStyling }},[(!_vm.instance)?_c('div',{staticClass:"dz-default dz-message"},[_vm._v("\n    "+_vm._s(_vm.defaultMessage)+"\n  ")]):[(_vm.hasDefaultSlot)?_vm._t("default",null,null,_vm.slotScope):_vm._e(),_c('div',{class:{
        'is-hidden': _vm.hasDefaultSlot,
        'dz-default dz-message': _vm.includeStyling
      }},[_vm._t("message",[_vm._v(_vm._s(_vm.defaultMessage))])],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }